import { Translations } from './translations'

export const es: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'Magnate del Entrenamiento de IA',
  settings: 'Ajustes',

  // Resources
  resources: 'Recursos',
  money: 'Dinero',
  energy: 'Energía',
  compute: 'Cómputo',
  quality: 'Calidad',
  totalUsers: 'Usuarios Totales',
  price: 'Precio',
  research: 'Investigación',

  // Actions
  train: 'Entrenar',
  trainCost: 'Costo',
  qualityGain: 'calidad',
  inference: 'Inferencia',
  needUsers: '¡Necesitas usuarios!',
  usersWaiting: 'usuarios esperando',
  qualityToAttract: 'Calidad > 40% para atraer',
  researchAction: 'Investigar',
  unlocksAfter: 'Se desbloquea después de',
  computeSpent: 'cómputo gastado',
  cost: 'Costo',

  // Hardware
  hardware: 'Hardware',
  computePerSec: 'cómputo/s',
  usesEnergy: 'usa',
  devicesTotal: 'dispositivos en total',

  // Models
  training: 'Entrenando',
  yourModels: 'Tus Modelos',
  params: 'parámetros',
  maxUsers: 'Máx usuarios',
  trainCost2: 'Costo entrenamiento',
  unlocked: 'desbloqueado',
  researchPoints: 'investigación',

  // Upgrades
  upgrades: 'Mejoras',
  upgradesLockedMsg: 'Entrena tu modelo al 50% de calidad para desbloquear mejoras',
  max: 'MÁX',

  // Footer
  computeSpentStat: 'Cómputo Gastado',
  time: 'Tiempo',
  resetGame: 'Reiniciar Juego',
  resetConfirm: '¿Estás seguro de que quieres reiniciar todo el progreso?',
  pause: 'Pausar',
  resume: 'Reanudar',

  // Event Log
  eventLog: 'Registro de Eventos',
  welcome: '¡Bienvenido a GPT Clicker! Entrena tu modelo para comenzar.',

  // Price
  market: 'Mercado',
  pricePerMillion: '$/1M tokens',

  // Tags
  tagEnergy: 'ENRGÍA',
  tagCompute: 'CÓMP',
  tagHw: 'HW',
  tagTrain: 'ENTR',
  tagResearch: 'INVEST',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Año 2020. Tienes una idea: entrenar un pequeño modelo de lenguaje basado en la arquitectura transformer.',
  tutorialFirstTrain: '¡Entrenamiento iniciado! Tu laptop convierte energía en cómputo. Cada entrenamiento mejora la calidad del modelo.',
  tutorialQuality20: 'El modelo está aprendiendo patrones básicos. Sigue entrenando para mejorar la calidad.',
  tutorialQuality40: '¡Calidad sobre 40%! Tu modelo ahora puede generar texto algo coherente. Los usuarios están empezando a notarlo...',
  tutorialQuality50: '¡Mejoras desbloqueadas! Usa tus ganancias para comprar mejor hardware y expandir tu capacidad de energía.',
  tutorialFirstUsers: '¡Tus primeros usuarios! Haz clic en INFERENCIA para atender sus solicitudes y ganar dinero.',
  tutorialUsers10: 'La voz se está corriendo. Más usuarios están probando tu modelo. Considera subir el precio...',
  tutorialMoney100: '¡Tienes $100! Es hora de mejorar tu hardware. Mejores GPUs = más cómputo = entrenamiento más rápido.',
  tutorialMoney1k: 'Tu pequeño proyecto de IA se está convirtiendo en un negocio real. Los inversores están empezando a llamar...',
  tutorialResearchUnlock: '¡INVESTIGACIÓN desbloqueada! Gasta cómputo en investigación para desbloquear modelos más grandes y poderosos.',
  tutorialFirstResearch: 'Los puntos de investigación se acumulan. Cuando tengas suficientes, podrás desbloquear la siguiente arquitectura de modelo.',
  tutorialGpt2Small: '¡GPT-2 Small desbloqueado! Esta arquitectura puede manejar tareas más complejas. Entrenalo desde cero.',
  tutorialGpt2Large: '¡GPT-2 Large! La gente dice que esto podría ser "demasiado peligroso para publicar"...',
  tutorialGpt3: 'Comienza la era de GPT-3. El aprendizaje few-shot lo cambia todo. El mundo está observando.',
  tutorialGpt4: 'GPT-4 está aquí. Multimodal, razonamiento, y aterradoramente capaz. La carrera de IA se intensifica.',
  tutorialAgi: 'Lo lograste. La AGI está aquí. Entiende. Se mejora a sí misma. Lo que pase después depende de ti...',
  tutorialHwGaming: '¡Buena GPU! El entrenamiento es mucho más rápido ahora. Tus vecinos podrían quejarse de la cuenta de luz.',
  tutorialHwServer: '¡Un rack de servidores real! Has salido del garaje. Es hora de alquilar una oficina.',
  tutorialHwDatacenter: '¡Tu propio datacenter! Ahora estás compitiendo con las grandes empresas de tecnología.',
  tutorialHwSatellite: '¡Cómputo orbital! La constelación Moonlink proporciona poder de procesamiento sin precedentes desde el espacio.',
  tutorialHwQuantum: 'Supremacía cuántica lograda. El QC-1024 opera con principios que pondrían nervioso a Einstein.',
  tutorialUsers100: '¡100 usuarios! Estás ganando tracción. Los blogs de tecnología están escribiendo sobre ti.',
  tutorialUsers1k: '¡1,000 usuarios! Necesitas contratar un equipo de soporte. Y quizás algunos abogados.',
  tutorialUsers100k: '¡100K usuarios! Ahora eres una startup unicornio. Los VCs se pelean por darte dinero.',
  tutorialUsers1m: '¡UN MILLÓN DE USUARIOS! Estás remodelando cómo la humanidad interactúa con la tecnología.',

  // Model descriptions
  modelTinyDesc: 'Un humilde comienzo. Apenas coherente, pero funciona.',
  modelGpt2SmallDesc: 'El modelo que lo inició todo. Realmente útil.',
  modelGpt2LargeDesc: 'Demasiado peligroso para publicar... ¿o no?',
  modelGpt3Desc: 'Aprendizaje few-shot. El mundo toma nota.',
  modelGpt4Desc: 'Multimodal. Razonamiento. Comienza la carrera armamentista.',
  modelAgiDesc: 'Entiende. Se mejora a sí misma. ¿Y ahora qué?',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Overclockear Laptop',
  upgradeLaptopOverclockDesc: 'Exige más a tu laptop: +2 cómputo/seg',
  upgradeBetterOutlet: 'Mejor Toma de Corriente',
  upgradeBetterOutletDesc: '+50 energía máxima',
  upgradeSolarPanel: 'Panel Solar',
  upgradeSolarPanelDesc: '+1 energía/seg regeneración',
  upgradePowerGrid: 'Conexión a Red Eléctrica',
  upgradePowerGridDesc: '+5 energía/seg regeneración',
  upgradeNuclearPlant: 'Planta Nuclear',
  upgradeNuclearPlantDesc: '+20 energía/seg regeneración',
  upgradeFusionReactor: 'Reactor de Fusión',
  upgradeFusionReactorDesc: '+100 energía/seg regeneración',
  upgradeDysonSphere: 'Esfera de Dyson',
  upgradeDysonSphereDesc: '+1000 energía/seg regeneración',
  upgradeRamUpgrade: 'Mejora de RAM',
  upgradeRamUpgradeDesc: '+50 cómputo máximo',
  upgradeSsdArray: 'Arreglo de SSDs',
  upgradeSsdArrayDesc: '+200 cómputo máximo',
  upgradeBetterOptimizer: 'Mejor Optimizador',
  upgradeBetterOptimizerDesc: '+20% eficiencia de entrenamiento',
  upgradeResearchPapers: 'Papers de Investigación',
  upgradeResearchPapersDesc: '+20% eficiencia de investigación',
  upgradeSelfServicePortal: 'Portal de Autoservicio',
  upgradeSelfServicePortalDesc: 'Los usuarios se sirven solos: 0.5 auto-inferencias/seg',
  upgradeApiAccess: 'Acceso API',
  upgradeApiAccessDesc: 'Los desarrolladores integran tu modelo: +1 auto-inferencia/seg',
  upgradeMobileApp: 'App Móvil',
  upgradeMobileAppDesc: 'Usuarios en movimiento: +2 auto-inferencias/seg',
  upgradeEnterpriseTier: 'Tier Empresarial',
  upgradeEnterpriseTierDesc: 'Grandes clientes, gran volumen: +5 auto-inferencias/seg',
  upgradeGlobalCdn: 'CDN Global',
  upgradeGlobalCdnDesc: 'Baja latencia mundial: +10 auto-inferencias/seg',
  upgradeBasicChatbot: 'Chatbot Básico',
  upgradeBasicChatbotDesc: 'Un widget web simple: +0.2 auto-inferencias/seg',

  // Hardware upgrade descriptions
  hwUsedGpuDesc: 'GPU usada: +3 cómputo/seg',
  hwGamingGpuDesc: 'GPU gaming: +8 cómputo/seg',
  hwProGpuDesc: 'GPU pro: +20 cómputo/seg',
  hwWorkstationDesc: 'Workstation: +50 cómputo/seg',
  hwServerRackDesc: 'Rack de servidores (4x A100): +120 cómputo/seg',
  hwGpuClusterDesc: 'Cluster de GPUs (8x H100): +300 cómputo/seg',
  hwMiniDatacenterDesc: 'Datacenter edge: +800 cómputo/seg',
  hwDatacenterDesc: 'Datacenter: +2K cómputo/seg',
  hwMegaDatacenterDesc: 'Mega datacenter: +5K cómputo/seg',
  hwDatacenterNetworkDesc: 'Red global: +15K cómputo/seg',
  hwSupercomputerDesc: 'Supercomputadora: +50K cómputo/seg',
  hwSatelliteDesc: 'Satélites orbitales: +200K cómputo/seg',
  hwQuantumDesc: 'Computadora cuántica: +1M cómputo/seg',

  // Misc
  purchased: 'Comprado',
  switchedTo: 'Cambiado a entrenar',
  unlockedModel: 'Desbloqueado',
  scalesToUsers: 'Escala a',
  trainItToAttract: 'usuarios. ¡Entrenalo para atraer usuarios!',
  unlimited: 'ilimitado',
  language: 'Idioma',
  
  // Mobile labels
  mobileResources: 'Recursos',
  mobileModels: 'Modelos',
  mobileHardware: 'Hardware',
  mobileUpgrades: 'Mejoras',
  sell: 'Vender',
  sellFor: 'Vender por',
  discontinueConfirm: '¿Discontinuar {model}? Los usuarios migrarán a otros modelos.',
  autoInference: 'Auto-inferencia',
  autoInferenceRate: 'Auto Infer',
  autoTrain: 'Auto-entrenamiento',
  autoTrainRate: 'Auto Train',
  autoResearch: 'Auto-investigación',
  autoResearchRate: 'Auto Research',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Entrena modelos de IA, atiende usuarios, ¡construye tu imperio de IA!',
  tooltipMoney: 'Dinero - Ganado de las inferencias de usuarios. Úsalo para comprar mejoras y hardware.',
  tooltipEnergy: 'Energía - Se regenera con el tiempo. Alimenta tu hardware para generar cómputo.',
  tooltipCompute: 'Cómputo - Generado por hardware. Usado para entrenamiento, inferencia e investigación.',
  tooltipResearch: 'Puntos de Investigación - Gasta cómputo para ganar PI. Usa PI para desbloquear nuevos modelos.',
  tooltipUsers: 'Usuarios - Atraídos por la calidad del modelo. Más usuarios = más ingresos por inferencia.',
  tooltipComputeSpent: 'Cómputo Total Gastado - Cómputo usado en entrenamiento e investigación.',
  tooltipPlayTime: 'Tiempo de Juego - Cuánto tiempo llevas construyendo tu imperio de IA.',
  tooltipSettings: 'Ajustes - Opciones de depuración, reiniciar juego',

  // Share
  shareButton: 'Compartir',
  shareText: '¡Estoy construyendo un imperio de IA en GPT Clicker! {users} usuarios, {money} de ingresos, entrenando {model}. ¿Puedes superar mi partida de {time}?',
  shareCopied: '¡Texto copiado!',
  imageCopied: '¡Imagen copiada!',
  shareChallenge: '¿Podés superarme?',
  shareTitle: 'Compartí tu progreso',
  shareDownload: 'Guardar Imagen',
  model: 'Modelo',

  // Feedback
  feedback: 'Feedback',
  feedbackTitle: 'Enviar Feedback',
  feedbackPlaceholder: 'Contanos qué te parece GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (opcional)',
  feedbackSend: 'Enviar',
  feedbackSending: 'Enviando...',
  feedbackSuccess: '¡Gracias por tu feedback!',
  feedbackError: 'Error al enviar feedback. Intentá de nuevo.',
  feedbackRateLimit: 'Demasiadas solicitudes. Esperá antes de enviar más feedback.',
  feedbackClose: 'Cerrar',

  // Console messages
  consoleGameLoaded: 'Juego cargado desde guardado',
  consoleGameSaved: 'Juego guardado',
  consoleFailedToSave: 'Error al guardar juego:',
  consoleFailedToLoad: 'Error al cargar juego:',
  consoleFailedToClear: 'Error al borrar guardado:',

  // Victory
  victoryTitle: '¡Felicitaciones!',
  victorySubtitle: 'La Civilización Humana ha alcanzado la Singularidad',
  victoryTime: 'Tiempo hasta la Singularidad',
  victoryCta: '¿Deberíamos hacer Singularity Clicker? ¡Dejá un comentario en redes sociales!',
  victoryClose: 'Seguir Jugando',
}
